import React,{ useEffect, useState} from "react";
import "./Service.css";
import { Link } from "react-router-dom";


const Service = () => {
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
    const [menuOpen, setMenuOpen] = useState(false);
    useEffect(() => {
      const navbar = document.querySelector("header, .navbar");
      const footer = document.querySelector("footer");
    
     
      if (navbar) navbar.style.display = "none";
      if (footer) footer.style.display = "none";
    
      return () => {
        // 🔥 மீண்டும் restore
        if (navbar) navbar.style.display = "";
        if (footer) footer.style.display = "";
      };
    }, []);
    


  return (
 <> 
  {/* Navbar */}
  <header className="service-navbar">
  <div className="service-navbar-container">

    <div className="service-logo">
      <img
        src="/Logo.png"
        alt="logo"
        className="service-logo-img"
      />
      <span className="logo-text">
        Forge<span>Your</span>Peak
      </span>
    </div>

    {/* Mobile Hamburger */}
    <button
      className="hamburger"
      onClick={() => setMenuOpen(!menuOpen)}
    >
      ☰
    </button>

    {/* Desktop Menu */}
    <nav className={`service-nav-links ${menuOpen ? "active" : ""}`}>
        <a href="#bootcamp">Bootcamp</a>
        <a href="#ignite">Ignite</a>
        <a href="#vision">Vision Ignite</a>

        <a
            href="https://forgeyourpeak.in/ignite-payment"
            target="_blank"
            rel="noopener noreferrer"
        >
            <button className="mobile-ignite-btn">
            Join Ignite — ₹8,999
            </button>
        </a>
        </nav>

  </div>
    </header>
    <section className="hero">
      {/* Top Image Area */}
         
        <div className="hero-content">

        <div className="hero-left">
            <span className="tag">
            VISUAL PERFORMANCE PLATFORM
            </span>
            <h1 className="heroV2-title">
            Train your brain.<br />
            Sharpen your reflexes.<br />
            Perform under pressure.</h1>

            <div className="quote-box">
            <p>
                ""You've been grinding at the gym, on the field, in practice. But your slow first step, late ball pickup, and inconsistent timing? That's not fitness — that's your visual system. And it's trainable.""
            </p>
            
            </div>
            <p className="digital">Forge Your Peak is a digital performance platform for competitive athletes. We train visual processing, reaction speed, and neural performance — the hidden edge your gym doesn't touch.</p>
            <div className="heroV2-ctaRow">
            <Link className="heroV2-primary" to="/webinar">
                 Join Free Webinar
            </Link>
            <a className="heroV2-secondary" href="https://calendly.com/forgeyourpeak-support/book_call">
              Book a Discovery Call
            </a>
          </div>
        </div>

        <div className="hero-right">

            <div className="hero-image-wrapper">
               <img
                    src="/Hero/Vevek-hero.jpeg"
                    alt="Athlete Training"
                    className="hero-image"
                />
            </div>

            <h3 className="athlet-subtitle">THE PROBLEMS HOLDING ATHLETES BACK</h3>

            <div className="problem-card">
            <span></span>
            <p>Late ball pickup</p>
            </div>

            <div className="problem-card">
            <span></span>
            <p>Slow first step</p>
            </div>

            <div className="problem-card">
            <span></span>
            <p>Inconsistent timing</p>
            </div>

            <div className="problem-card">
            <span></span>
            <p>Eye fatigue mid-game</p>
            </div>

            <div className="problem-card">
            <span></span>
            <p>Poor decision clarity under pressure</p>
            </div>

        </div>

        </div>
        <div className="pricing-section">

        <div className="pricing-badge-wrapper">
            <div className="line"></div>
            <div className="pricing-badge">
            THREE PROGRAMS. ONE SYSTEM.
            </div>
            <div className="line"></div>
        </div>

        <div className="pricing-top-cards">

            <div className="top-card">
            <h4>BOOTCAMP</h4>
            <h2>₹499</h2>
            <h3>3-Day Visual Reset</h3>
            <p>
                The entry point. Feel the difference before
                committing to more.
            </p>
            </div>

            <div className="top-card">
            <h4 className="purple">FYP IGNITE</h4>
            <h2 className="purple">₹8,999</h2>
            <h3>Full Performance Program</h3>
            <p>
                5 pillars, weekly coaching. Built for serious
                athletes.
            </p>
            </div>

            <div className="top-card">
            <h4 className="removeglass">VISION IGNITE</h4>
            <h2 className="removeglass">₹8,999</h2>
            <h3>Daily Eye-Health Membership</h3>
            <p>
                For athletes and everyday people. Reduce
                screen strain, see clearer.
            </p>
            </div>

        </div>

        <div className="pricing-grid">

            <div className="price-card bootcamp">
            <div className="price-header">
                <span>BOOTCAMP</span>
                <h2>Reset Your Eyes. React Faster. Perform Sharper.</h2>
                <h3>₹499</h3>
            </div>

            <div className="price-body">
                <ul>
                <li>3-Day guided visual reset system</li>
                <li>Visual fatigue recovery protocol</li>
                <li>Reaction trigger activation drills</li>
                <li>Self-check progress framework</li>
                <li>Private athlete community access</li>
                </ul>
                <a
                href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button>Join Bootcamp — ₹499</button>
                </a>
            </div>
            </div>

            <div  className="price-card ignite">
            <div className="price-header">
                <span>FYP IGNITE</span>
                <h2>Build Your Competitive Edge.</h2>
                <h3>₹8,999</h3>
            </div>

            <div className="price-body">
                <ul>
                <li>Neural Performance Core foundation</li>
                <li>5 pillar mini-courses</li>
                <li>Performance-athon hackathon weeks</li>
                <li>Weekly coaching</li>
                <li>Private community access</li>
                </ul>

                <a
                    href="https://forgeyourpeak.in/ignite-payment"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <button className="ignite-btn">
                        Join Ignite — ₹8,999
                    </button>
                </a>
            </div>
            </div>

            <div  className="price-card vision">
            <div className="price-header">
                <span>VISION IGNITE</span>
                <h2>Reduce Your Dependence on Glasses.</h2>
                <h3>₹8,999</h3>
            </div>

            <div className="price-body">
                <ul>
                <li>Eye Health Reset Foundation</li>
                <li>Daily vision training library</li>
                <li>Visual acuity tracking guidance</li>
                <li>Monthly practice challenges</li>
                <li>Community support</li>
                </ul>

                <a
                    href="https://forgeyourpeak.in/vision-ignite-payment"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <button className="vision-btn-outline">
                        Vision Ignite — ₹8,999
                    </button>
                    </a>
            </div>
            </div>

            </div>

            </div>
       <div className="bootcamp-section">
        <div className="bootcamp-container">

            <div  id="bootcamp" className="bootcamp-badge">
            BOOTCAMP • ₹499
            </div>

            <h2 className="bootcamp-title">
            3 days. Measurable change.
            <br />
            A protocol you keep forever.
            </h2>

            <p className="bootcamp-description">
            Each day builds on the last. By Day 3 you have a match-day visual
            reset protocol you can use immediately — before every game,
            every session, every competition.
            </p>

            <div className="days-grid">

            <div className="day-card">
                <span className="day-label">DAY 1</span>
                <h3>Test</h3>

                <ul>
                <li>Measure visual clarity</li>
                <li>Measure neural-processing speed</li>
                <li>Benchmark your baseline</li>
                </ul>
            </div>

            <div className="day-card">
                <span className="day-label">DAY 2</span>
                <h3>Train</h3>

                <ul>
                <li>Learn to rest your visual system</li>
                <li>Improve hand-eye coordination</li>
                <li>Train your brain for faster reactions</li>
                </ul>
            </div>

            <div className="day-card">
                <span className="day-label">DAY 3</span>
                <h3>Transform</h3>

                <ul>
                <li>Match-day carryover plan</li>
                <li>Basic visual reset protocol</li>
                <li>Gateway to FYP Ignite</li>
                </ul>
            </div>

            </div>

            <div className="quote-card">
            "Your body is ready. Is your visual system?" —
            The question most coaches never ask.
            </div>
            <a
                href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button>Start a Bootcamp — ₹499</button>
                </a>
           

        </div>
        </div>
    <div className="ignite-section">
        <div className="ignite-container">

            <div id="ignite" className="ignite-badge">
            FYP IGNITE • ₹8,999
            </div>

            <h2 className="ignite-title">
            Five pillars. One serious athlete.
            </h2>

            <p className="ignite-description">
            Each pillar is a training focus with a direct on-field outcome.
            This is a structured system built around weekly coaching —
            not a video library you forget about.
            </p>

            <div className="pillars-grid">

            <div className="pillar-card">
                <div className="pillar-icon">👁️</div>
                <h3>Vision</h3>
                <p>
                Clarity, tracking, depth, and focus control under speed.
                </p>
            </div>

            <div className="pillar-card">
                <div className="pillar-icon">🤝</div>
                <h3>Hand-Eye</h3>
                <p>
                Timing, contact quality, and exact coordination loops.
                </p>
            </div>

            <div className="pillar-card">
                <div className="pillar-icon">🧠</div>
                <h3>Memory</h3>
                <p>
                Pattern retention, recall speed, and decision stability.
                </p>
            </div>

            <div className="pillar-card">
                <div className="pillar-icon">⚡</div>
                <h3>Anticipation</h3>
                <p>
                Earlier cue pickup and improved prediction accuracy.
                </p>
            </div>

            <div className="pillar-card">
                <div className="pillar-icon">🌙</div>
                <h3>Sleep</h3>
                <p>
                Recovery protocols that protect speed, learning, and consistency.
                </p>
            </div>

            </div>

            <h3 className="whats-inside-title">
            What's inside
            </h3>

            <div className="inside-card">
            <div className="inside-number">1</div>

            <div className="inside-content">
                <h3>Neural Performance Core</h3>
                <p>
                The foundation — upgrade the brain behind the
                performance before anything else.
                </p>
            </div>
            </div>

            <div className="inside-card">
            <div className="inside-number">2</div>

            <div className="inside-content">
                <h3>Pillar mini-courses</h3>
                <p>
                Short, focused, step-by-step courses for each of
                the five pillars.
                </p>
            </div>
            </div>

            <div className="inside-card">
            <div className="inside-number">3</div>

            <div className="inside-content">
                <h3>Performance-athon weeks</h3>
                <p>
                Live sprint weeks — learn, troubleshoot and level up
                with the group.
                </p>
            </div>
            </div>

            <div className="inside-card">
            <div className="inside-number">4</div>

            <div className="inside-content">
                <h3>Inner Circle weekly coaching</h3>
                <p>
                Weekly sessions for accountability,
                corrections and steady progress.
                </p>
            </div>
            </div>

            <div className="inside-card">
            <div className="inside-number">5</div>

            <div className="inside-content">
                <h3>Private community</h3>
                <p>
                Support, check-ins and guidance to stay
                consistent and motivated.
                </p>
            </div>
            </div>

            <div className="ignite-footer">
            <p>
                Limited cohort seats • Weekly structure •
                Built for serious athletes
            </p>

            <a
            href="https://forgeyourpeak.in/ignite-payment"
            target="_blank"
            rel="noopener noreferrer"
            >
            <button className="ignite-btn">
                Join Ignite — ₹8,999
            </button>
            </a>
            </div>

        </div>
        </div>
    <div className="vision-section">
        <div className="vision-container">

            <div id="vision" className="visionignite-badge">
            VISION IGNITE • ₹8,999
            </div>

            <h2 className="vision-title">
            Train your eyes daily.
            <br />
            Reduce the strain. See clearer.
            </h2>

            <p className="vision-description">
            10–15 minutes a day. Built around habits most people never
            knew they needed. A system for healthier, calmer and
            more resilient vision.
            </p>

            <div className="vision-pillars">

            <div className="vision-card">
                <h3>😌 Eye Relaxation</h3>
                <p>Palming, breath and nervous-system calming.</p>
            </div>

            <div className="vision-card">
                <h3>🔍 Focus Flexibility</h3>
                <p>Near-far shifting to reduce screen stiffness.</p>
            </div>

            <div className="vision-card">
                <h3>⛰️ Distance Vision</h3>
                <p>Rebuild the habit of looking far naturally.</p>
            </div>

            <div className="vision-card">
                <h3>🌀 Visual Awareness</h3>
                <p>Peripheral awareness and attention training.</p>
            </div>

            <div className="vision-card">
                <h3>☀️ Recovery Habits</h3>
                <p>Sleep, sunlight and screen breaks.</p>
            </div>

            </div>

            <h3 className="section-subtitle">Who is this for?</h3>

            <div className="audience-grid">

            <div className="audience-card">
                <h3>📚 Students</h3>
                <p>
                Better screen habits and protected visual attention.
                </p>
            </div>

            <div className="audience-card active">
                <h3>💼 Working Professionals</h3>
                <p>
                Reduce screen strain after long workdays.
                </p>
            </div>

            <div className="audience-card">
                <h3>👨‍👩‍👧 Families</h3>
                <p>
                Healthy visual habits for the whole family.
                </p>
            </div>

            </div>

            <h3 className="section-subtitle">What's inside</h3>

            <div className="inside-item">
            <span>1</span>
            <div>
                <h4>Eye Health Reset Core</h4>
                <p>Understand how vision works and strain builds.</p>
            </div>
            </div>

            <div className="inside-item">
            <span>2</span>
            <div>
                <h4>Daily Vision Rituals</h4>
                <p>Guided routines for daily eye health.</p>
            </div>
            </div>

            <div className="inside-item">
            <span>3</span>
            <div>
                <h4>Visual Acuity Tracking</h4>
                <p>Track improvements month by month.</p>
            </div>
            </div>

            <div className="inside-item">
            <span>4</span>
            <div>
                <h4>Monthly Challenges</h4>
                <p>Practice sprints that build consistency.</p>
            </div>
            </div>

            <div className="inside-item">
            <span>5</span>
            <div>
                <h4>Community Access</h4>
                <p>Share progress and get support.</p>
            </div>
            </div>

            <h3 className="section-subtitle">Common Questions</h3>

            <div className="faq-card">
            <h4>Will this remove my glasses completely?</h4>
            <p>
                The goal is to improve visual habits and reduce dependence
                where possible.
            </p>
            </div>

            <div className="faq-card">
            <h4>How much time does it take daily?</h4>
            <p>Most routines take 10–15 minutes per day.</p>
            </div>

            <div className="faq-card">
            <h4>Is this only for athletes?</h4>
            <p>No. Anyone can benefit from healthier vision habits.</p>
            </div>

            <div className="vision-note">
            Vision Ignite is educational and not a medical treatment.
            </div>

            <a
                href="https://forgeyourpeak.in/vision-ignite-payment"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button className="vision-btn">
                    Join Vision Ignite — ₹8,999 →
                </button>
                </a>

        </div>
        </div>
    <div className="cta-section">
        <div className="cta-container">

            <div className="cta-badge">
            READY?
            </div>

            <h2 className="cta-title">
            The gym trains your body.
            <br />
            <span>Forge Your Peak trains the rest.</span>
            </h2>

            <p className="cta-description">
            Visual processing. Reaction speed. Neural performance.
            The edge every competitive athlete is missing —
            and almost no one is training.
            </p>

            <p className="cta-price">
            Start for ₹499 today.
            </p>

            <div className="cta-buttons">
            <a
                href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button className="bootcamp-outline-btn">
                    Start With Bootcamp — ₹499
                </button>
                </a>
            <a
            href="https://forgeyourpeak.in/ignite-payment"
            target="_blank"
            rel="noopener noreferrer"
            >
            <button className="ignite-outline-btn">
                Go straight to Ignite — ₹8,999
            </button>
            </a>

            <a
            href="https://forgeyourpeak.in/vision-ignite-payment"
            target="_blank"
            rel="noopener noreferrer"
            >
            <button className="vision-outline-btn">
                Vision Ignite — ₹8,999
            </button>
            </a>
            </div>

            <div className="cta-meta">
            Digital access • Instant start • forgeyourpeak.in
            </div>

        </div>

        <div className="footer-bar">
            <div className="footer-logo">
            Forge<span>YourPeak</span>
            </div>

            <div className="footer-copy">
            © 2025 forgeyourpeak.in · All rights reserved
            </div>
        </div>
        </div>
    
    </section>
    </>
  );
};

export default Service;